<template>
  <globalNavigation :navData="navData" :navExpanded="navExpanded" />
</template>

<script>
/**
 * @fileoverview Side Navigation
 * Relies on vuex for mapping state variables.
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

import { mapGetters } from "vuex";

import globalNavigation from "@/qux-common/qux22/components/organisms/global-navigation";

export default {
  components: {
    globalNavigation,
  },
  computed: {
    navData() {
      const navData = [
        {
          name: "Management",
          links: [
            {
              name: "Clients",
              href: "/clients",
              icon: '$client',
              links: [
                {
                  name: "Templates",
                  href: "/clients/templates",
                  icon: '$templates',
                },
              ],
            },
          ],
        },
      ];
      return navData;
    },
    ...mapGetters({
      navExpanded: "getNavExpanded",
    }),
  },
};
</script>

<style lang="scss" scoped>
.navigation-wrapper {
  grid-area: sidenav;
}
</style>